export type DistributionPartner = {
  id: string;
  name: string;
  sub?: string;
  variant: 'serif' | 'sans' | 'bold' | 'badge';
  mark?: string;
  icon?: string;
};

export const distributionPartners: DistributionPartner[] = [
  {
    id: 'bam',
    name: 'BAM!',
    sub: 'Books-A-Million',
    variant: 'bold',
  },
  {
    id: 'amazon-kindle',
    name: 'amazonkindle',
    variant: 'sans',
  },
  {
    id: 'powells',
    name: "POWELL'S",
    sub: 'City of Books',
    variant: 'serif',
  },
  {
    id: 'loc',
    name: 'LIBRARY',
    sub: 'of Congress',
    variant: 'serif',
  },
  {
    id: 'booktopia',
    name: 'booktopia',
    variant: 'sans',
  },
  {
    id: 'barnes-noble',
    name: 'BARNES & NOBLE',
    variant: 'serif',
  },
  {
    id: 'book-depository',
    name: 'Book Depository',
    variant: 'bold',
    icon: 'ri-book-open-line',
  },
  {
    id: 'blackwells',
    name: "Blackwell's",
    variant: 'badge',
    mark: 'B',
  },
  {
    id: 'mcnally-robinson',
    name: 'McNALLY ROBINSON',
    variant: 'serif',
  },
  {
    id: 'booksprout',
    name: 'Booksprout',
    variant: 'bold',
    icon: 'ri-bookmark-line',
  },
  {
    id: 'waterstones',
    name: 'Waterstones',
    variant: 'serif',
  },
  {
    id: 'indigo',
    name: 'Indigo',
    variant: 'badge',
    mark: 'I',
  },
];